module.exports = __webpack_public_path__ + "410373a8091346e7ae164c9b20504e59.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/muhimma-logo.png
// module id = 1527
// module chunks = 0